// Text-to-speech for Norwegian, tuned for absolute beginners.
//
// Why rate 0.85? Norwegian vowel length and pitch accent (the "two melodies")
// disappear at native speed for an untrained ear. 0.85 gives roughly a
// fifteen-percent stretch, which is enough to hear /æ/, /ø/, /å/ clearly
// without sounding robotic.

let voicesCache = null;

function loadVoices() {
  return new Promise(resolve => {
    const initial = window.speechSynthesis.getVoices();
    if (initial.length) {
      voicesCache = initial;
      return resolve(initial);
    }
    // Chromium/Firefox load voices asynchronously on first call.
    window.speechSynthesis.addEventListener(
      'voiceschanged',
      () => {
        voicesCache = window.speechSynthesis.getVoices();
        resolve(voicesCache);
      },
      { once: true }
    );
  });
}

// Prefer strict no-NO, then any Bokmål voice, then any Norwegian variant.
function pickNorwegianVoice(voices) {
  return (
    voices.find(v => v.lang === 'no-NO') ||
    voices.find(v => v.lang?.toLowerCase().startsWith('nb')) ||
    voices.find(v => v.lang?.toLowerCase().startsWith('no')) ||
    null
  );
}

export async function speak(text, { rate = 0.85, onStart, onEnd } = {}) {
  if (!ttsAvailable()) {
    onEnd?.();
    return;
  }
  // Cancel any in-flight utterance so rapid presses feel responsive.
  window.speechSynthesis.cancel();

  const voices = voicesCache || (await loadVoices());
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = 'no-NO';
  utter.rate = rate;
  utter.pitch = 1;
  utter.volume = 1;

  const voice = pickNorwegianVoice(voices);
  if (voice) utter.voice = voice;

  utter.onstart = () => onStart?.();
  utter.onend = () => onEnd?.();
  utter.onerror = () => onEnd?.();

  window.speechSynthesis.speak(utter);
}

export function ttsAvailable() {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

// Warm the voice list up front so the first press isn't slow.
if (ttsAvailable()) loadVoices();
